import { useState } from "react";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { useLogout } from "../../firebase-files/hooks/useLogout";
import { useCollection } from "../../firebase-files/hooks/useCollection";
// components
import BookingList from "../../default-pages/bookings/BookingList";
// styles
// import './UserDashboard.css'
const bookingFilter = ["PENDING", "COMPLETED", "CANCELLED", "INACTIVE"];

export default function PGCustomerBooking() {
  const { user } = useAuthContext();
  const { logout, isPending } = useLogout();
  const { documents: bookingdocuments, error: bookingerror } =
    // use this for descending order
    useCollection("bookings", null, ["bookingDate", "desc"]);
  // useCollection("bookings", ["userid", "==", user.uid]);
  // useCollection("bookings", ["createdBy:id", "==", user.uid]);

  // use this for ascending order
  // useCollection("bookings", null, ["bookingDate", "asc"]);

  // if we want to arrange order with more than one field then the syntax is
  // useCollection("bookings", null, [["bookingDate", "asc"], ["bookingTime", "desc"]]);

  const [filter, setFilter] = useState("PENDING");

  const changeFilter = (newFilter) => {
    setFilter(newFilter);
  };

  const bookings = bookingdocuments
    ? bookingdocuments.filter((document) => {
        let filteredProperty = false;
        switch (filter) {
          case "PENDING":
            if (document.status === "pending") {
              filteredProperty = true;
            }
            return filteredProperty;
          case "COMPLETED":
            if (document.status === "completed") {
              filteredProperty = true;
            }
            return filteredProperty;
          case "CANCELLED":
            if (document.status === "cancelled") {
              filteredProperty = true;
            }
            return filteredProperty;
          default:
            return true;
        }
      })
    : null;

  return (
    <div className="pgadmindasboard pg_padding">
      <div>{bookings && <BookingList bookings={bookings} />}</div>
    </div>
  );
}
